import { ComponentProps, forwardRef } from "react";
import { clsx } from "clsx";

export const Container = forwardRef<HTMLDivElement, ComponentProps<"div">>(
  function Container({ className, ...props }, ref) {
    return (
      <div
        ref={ref}
        className={clsx(
          "p-4 md:p-8 max-w-screen-2xl mx-auto w-full",
          className,
        )}
        {...props}
      />
    );
  },
);
